import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

export const MentionsLegales = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-sand-50">
      <div className="bg-white border-b border-sand-200 px-6 py-4 sticky top-0 z-10">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="text-xl font-serif text-sage-700">Mentions légales</h1>
        </div>
      </div>

      <div className="px-6 py-8 max-w-2xl mx-auto prose prose-sage">
        <h2>Éditeur du site</h2>
        <p>
          <strong>Déclic RePas</strong><br />
          Lynda Bry-Bonnard<br />
          Auto-entrepreneur<br />
          Email : brylynda@gmail.com<br />
          Téléphone : 06 64 26 00 50
        </p>

        <h2>Hébergement</h2>
        <p>
          Ce site est hébergé par Emergent Labs.<br />
        </p>

        <h2>Propriété intellectuelle</h2>
        <p>
          L'ensemble du contenu de ce site (textes, images, vidéos, logos, etc.) est protégé par le droit d'auteur. 
          Toute reproduction, même partielle, est interdite sans autorisation préalable de l'éditeur.
        </p>

        <h2>Responsabilité</h2>
        <p>
          Les informations fournies sur ce site le sont à titre indicatif. L'éditeur ne saurait être tenu 
          responsable des erreurs ou omissions, ni des résultats qui pourraient être obtenus par un mauvais 
          usage de ces informations.
        </p>

        <h2>Contact</h2>
        <p>
          Pour toute question, vous pouvez nous contacter à l'adresse : brylynda@gmail.com
        </p>
      </div>
    </div>
  );
};

export default MentionsLegales;
